import ActionTypes from './ActionTypes';
import Dispatcher from './Dispatcher';

export default {
  fetch() {
    Dispatcher.dispatch({
      actionType: ActionTypes.USER_STORE_FETCH,
    });
  },

  updateLanguage(language) {
    Dispatcher.dispatch({
      actionType: ActionTypes.USER_STORE_UPDATE_LANGUAGE,
      language,
    });
  },
}
